import { Box, Container, Button, TextField, Grid, Card, CardContent, Typography, CircularProgress, MenuItem } from "@mui/material";
import { SettingsOutlined, SaveOutlined, SupportAgentOutlined, PaymentOutlined, GavelOutlined, CardGiftcardOutlined } from "@mui/icons-material";
import swal from "sweetalert";
import { t } from "i18next";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; 
import React, { useEffect, useState } from "react";

// ==========================================
// THEME CHUẨN KÈM FONT PLUS JAKARTA SANS
// ==========================================
const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        danger: { main: "#F1416C", light: "#FFF5F8" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
        info: { main: "#7239EA", light: "#F8F5FF" }, // Thêm màu cho giftcode
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF", marginBottom: "24px" } } },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif", textTransform: 'none' } } }
    }
});

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

function Setting() {
  const [setting, setSetting] = useState();
    const [load, setLoad] = useState(false); // Chuyển mặc định thành false
    const [profile] = useState(JSON.parse(localStorage.getItem("profile")));
    
    // 1. TẠO HÀM FETCH DATA RIÊNG
    const fetchSettingData = () => {
        setLoad(true);
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {})
            .then((res) => {
                setSetting(res.data.data[0]);
                setLoad(false); // Lấy data xong thì tắt loading
            })
            .catch(() => setLoad(false));
    };

    // 2. CHỈ GỌI 1 LẦN KHI VÀO TRANG
    useEffect(() => {
        fetchSettingData();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoad(true); // Bật hiệu ứng xoay xoay khi bắt đầu lưu
        
        const formData = {
            id: setting?._id,
            cskh: e.target.cskh.value,
            cskh2: e.target.cskh2.value,
            rating: Number(e.target.rating.value),
            minnap: Number(e.target.minnap.value),
            maxnap: Number(e.target.maxnap.value),
            minrut: Number(e.target.minrut.value),
            maxrut: Number(e.target.maxrut.value),
            mincuoc: Number(e.target.mincuoc.value),
            maxcuoc: Number(e.target.maxcuoc.value),
            maxlo: Number(e.target.maxlo.value),
            maxde: Number(e.target.maxde.value),
            kmnap: Number(e.target.kmnap.value),
            down_link: e.target.down_link.value,
            hoantra: Number(e.target.hoantra.value),
            autowinxs: Number(e.target.autowinxs?.value || 0),
            
            // DỮ LIỆU GIFTCODE
            naptien: Number(e.target.naptien.value),
            giftcode_amount: Number(e.target.giftcode_amount.value),
            giftcode_limit_ip: Number(e.target.giftcode_limit_ip.value),
            giftcode_status: e.target.giftcode_status.value === 'true'
        };
        
        axios
            .put(`${process.env.REACT_APP_API_URL}/setting/update`, formData)
            .then((res) => {
                // 3. ĐIỂM MẤU CHỐT: Lưu thành công -> Gọi lại hàm lấy dữ liệu mới nhất từ DB
                fetchSettingData(); 
                swal(t('success'), "Cập nhật cài đặt thành công!", "success");
            })
            .catch((res) => {
                setLoad(false);
                swal(t('error'), "Có lỗi xảy ra", "error");
            });
    };

    // Component tạo ô nhập liệu chuẩn (Hỗ trợ thêm dạng Select cho Boolean)
    const SettingInput = ({ label, name, defaultValue, type = "number", width = {xs: 12, sm: 6, md: 4}, highlightColor, options }) => (
        <Grid item {...width}>
            <Typography variant="caption" fontWeight="800" color="#7E8299" mb={1} display="flex" alignItems="center" gap={0.5} textTransform="uppercase">
                {highlightColor && <Box sx={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: highlightColor }} />}
                {label}
            </Typography>
            <TextField 
                select={type === "select"}
                fullWidth 
                name={name} 
                id={name} 
                type={type !== "select" ? type : undefined} 
                step={type === "number" ? "any" : undefined}
                defaultValue={defaultValue ?? (type === "select" ? "true" : "")} 
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: '#F9F9F9',
                        height: '42px',
                        '& fieldset': { borderColor: '#E4E6EF' },
                        '&:hover fieldset': { borderColor: '#B5B5C3' },
                        '&.Mui-focused fieldset': { borderColor: highlightColor || '#1B84FF', borderWidth: '1px' },
                    },
                    '& .MuiInputBase-input': { 
                        height: type === 'select' ? 'auto' : '42px', padding: type === 'select' ? '9px 14px' : '0 14px', boxSizing: 'border-box',
                        fontSize: '0.9rem', color: '#181C32', fontWeight: 600
                    }
                }} 
            >
                {type === "select" && options && options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
        </Grid>
    );

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                
                <ThemeProvider theme={metronicTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .safe-setting-general-zone * { font-family: 'Plus Jakarta Sans', sans-serif !important; }
                    `}</style>

                    <Box className="safe-setting-general-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)' }}>
                        
                        {load && (
                            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' }}>
                                <CircularProgress size={50} sx={{ color: '#1B84FF' }} />
                            </Box>
                        )}

                        <Container maxWidth="xl">
                            
                            {/* HEADER */}
                            <Box mb={4} display="flex" alignItems="center" gap={1.5}>
                                <SettingsOutlined sx={{ fontSize: '2.5rem', color: '#1B84FF' }} />
                                <Box>
                                    <Typography variant="h4" fontWeight="800" color="#181C32">Cài Đặt Hệ Thống</Typography>
                                    <Typography variant="body2" color="text.secondary">Thiết lập cấu hình giao dịch, hạn mức cược và thông tin liên hệ</Typography>
                                </Box>
                            </Box>

                                <form onSubmit={handleSubmit}>
                                    
                                    {/* ==========================================
                                        THÊM MỚI: CARD CẤU HÌNH GIFTCODE TÂN THỦ
                                    ========================================== */}
                                    <Card>
                                        <CardContent sx={{ p: 4 }}>
                                            <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                <CardGiftcardOutlined color="info" /> CẤU HÌNH GIFTCODE TÂN THỦ
                                            </Typography>
                                            <Grid container spacing={3}>
                                                <SettingInput 
                                                    label="Trạng Thái Tự Động Tạo Mã" 
                                                    name="giftcode_status" 
                                                    type="select" 
                                                    defaultValue={setting?.giftcode_status?.toString() ?? "true"} 
                                                    highlightColor="#7239EA"
                                                    options={[
                                                        { value: "true", label: "Bật (Tự tạo mã)" },
                                                        { value: "false", label: "Tắt (Không tạo)" }
                                                    ]}
                                                />
                                                <SettingInput 
                                                    label="Số Tiền Trong Mã (VNĐ)" 
                                                    name="giftcode_amount" 
                                                    defaultValue={setting?.giftcode_amount} 
                                                    highlightColor="#7239EA" 
                                                />
                                                <SettingInput 
                                                    label="Giới Hạn IP (Số mã/1 IP)" 
                                                    name="giftcode_limit_ip" 
                                                    defaultValue={setting?.giftcode_limit_ip} 
                                                    highlightColor="#7239EA" 
                                                />
                                            </Grid>
                                        </CardContent>
                                    </Card>
                               <Card>
                                        <CardContent sx={{ p: 4 }}>
                                            <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                <SupportAgentOutlined color="primary" /> Cấu hình Rút
                                            </Typography>
                                            <Grid container spacing={3}>
                                                <SettingInput label="Nạp tối thiểu mới được rút" name="naptien" type="text" defaultValue={setting?.naptien} highlightColor="#1B84FF" />
                                            </Grid>
                                        </CardContent>
                                    </Card>

                                    {/* 1. LIÊN HỆ & ỨNG DỤNG */}
                                    <Card>
                                        <CardContent sx={{ p: 4 }}>
                                            <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                <SupportAgentOutlined color="primary" /> LIÊN HỆ & ỨNG DỤNG
                                            </Typography>
                                            <Grid container spacing={3}>
                                                <SettingInput label="Link Tải App" name="down_link" type="text" defaultValue={setting?.down_link} highlightColor="#1B84FF" />
                                                <SettingInput label={`${t("service")} 1`} name="cskh" type="text" defaultValue={setting?.cskh} highlightColor="#1B84FF" />
                                                <SettingInput label={`${t("service")} 2`} name="cskh2" type="text" defaultValue={setting?.cskh2} highlightColor="#1B84FF" />
                                            </Grid>
                                        </CardContent>
                                    </Card>

                                    {/* 2. CẤU HÌNH GIAO DỊCH */}
                                    <Card>
                                        <CardContent sx={{ p: 4 }}>
                                            <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                <PaymentOutlined color="success" /> CẤU HÌNH NẠP / RÚT
                                            </Typography>
                                            <Grid container spacing={3}>
                                                <SettingInput label={t("min_recharge")} name="minnap" defaultValue={setting?.minnap} highlightColor="#50CD89" />
                                                <SettingInput label={t("max_recharge")} name="maxnap" defaultValue={setting?.maxnap} highlightColor="#50CD89" />
                                                <SettingInput label={`${t("promo_recharge")} (%)`} name="kmnap" defaultValue={setting?.kmnap} highlightColor="#FFC700" />
                                                
                                                <SettingInput label={t("min_withdraw")} name="minrut" defaultValue={setting?.minrut} highlightColor="#F1416C" />
                                                <SettingInput label={t("max_withdraw")} name="maxrut" defaultValue={setting?.maxrut} highlightColor="#F1416C" />
                                                <SettingInput label={`${t("rating")} (%)`} name="rating" defaultValue={setting?.rating} highlightColor="#F1416C" />
                                                
                                                <SettingInput label={`${t("refund_rate")} (%)`} name="hoantra" type="text" defaultValue={setting?.hoantra} highlightColor="#7239EA" />
                                            </Grid>
                                        </CardContent>
                                    </Card>

                                    {/* 3. GIỚI HẠN CƯỢC */}
                                    <Card>
                                        <CardContent sx={{ p: 4 }}>
                                            <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                <GavelOutlined color="warning" /> GIỚI HẠN ĐẶT CƯỢC
                                            </Typography>
                                            <Grid container spacing={3}>
                                                <SettingInput label={t("min_bet")} name="mincuoc" defaultValue={setting?.mincuoc} highlightColor="#FFC700" />
                                                <SettingInput label={t("max_bet")} name="maxcuoc" defaultValue={setting?.maxcuoc} highlightColor="#FFC700" />
                                                <SettingInput label="Giới hạn cược Lô" name="maxlo" defaultValue={setting?.maxlo} highlightColor="#FFC700" />
                                                <SettingInput label="Giới hạn cược Đề" name="maxde" defaultValue={setting?.maxde} highlightColor="#FFC700" />
                                                
                                                {/* Ẩn trường autowinxs như code gốc */}
                                                <Box display="none">
                                                    <input defaultValue={setting?.autowinxs} type="number" name="autowinxs" id="autowinxs" />
                                                </Box>
                                            </Grid>
                                        </CardContent>
                                    </Card>

                                    {/* NÚT LƯU STICKY */}
                                    <Box sx={{ position: 'sticky', bottom: 20, zIndex: 10, mt: 4, display: 'flex', justifyContent: 'center' }}>
                                        <Button 
                                            type="submit" 
                                            variant="contained" 
                                            color="primary" 
                                            startIcon={<SaveOutlined />}
                                            sx={{ 
                                                py: 1.5, px: 8, fontSize: '1.1rem', fontWeight: 800, borderRadius: '50px', 
                                                backgroundColor: '#181C32', color: '#FFF',
                                                boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.2)',
                                                transition: 'all 0.3s',
                                                '&:hover': { transform: 'translateY(-3px)', backgroundColor: '#3F4254', boxShadow: '0px 15px 40px rgba(0, 0, 0, 0.3)' }
                                            }}
                                        >
                                            {t("save")} CÀI ĐẶT
                                        </Button>
                                    </Box>

                                </form>
                         

                        </Container>
                    </Box>
                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default Setting;